<template>
  <div class="new">
    <component
      v-for="(item, index) in componentList"
      :key="index"
      :is="item.name"
    ></component>
    <div></div>
  </div>
</template>
<script>
import { Components } from "./components/component";
export default {
    components: Components,
    data(){
        return {
            componentList:[{
                name:"kepipei"
            }]
        }
    }
};
</script>
<style lang="less" scoped></style>
